$(document).on('turbolinks:load', function() {
  $(".show-more").click(function() {
    var url = location.href;
    location.href = "#order-repair";
    history.replaceState(null,null,url);
    $("#input-name").focus();
  });
});
